<template>
  <div>
    <v-btn @click="dialog_ativo = true; buscaProdutosLista()" icon>
      <v-icon>mdi-eye</v-icon>
    </v-btn>

    <v-dialog v-model="dialog_ativo" persistent content-class="bra-20" width="700" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="pt-4 pb-3">
          <span>Produtos da importação</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = ! dialog_ativo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-0 pl-5">
          <div class="my-2 pr-4">
            <v-text-field
              v-model="pesquisa"
              outlined
              dense
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              clearable
            />
          </div>

          <sys-data-table
            :items="produtos"
            :search="pesquisa"
            :headers="cabecalhos"
            :item-height="50"
            :height="alturaDaJanela - 350"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import responsiveHeight from '@/helpers/ResponsiveHeight.js';
import {buscaProdutosLista} from '@/api/Parametrizacao/CurvaCriticidade'

export default {
  name: "DialogListaProdutos",
  mixins: [responsiveHeight],
  props: {
    row: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    dialog_ativo: false,
    pesquisa: '',
    produtos: [],
    cabecalhos: [
      { text: 'id_produto', value: 'idproduto' },
      { text: 'nome_produto', value: 'descricao_produto' },
      { text: 'classificacao', value: 'curva_criticidade' },
    ]
  }),

  methods: {
    buscaProdutosLista() {
      this.$store.dispatch('loading/addRequisicao',
        buscaProdutosLista({ id: this.row.id }).then(produtos => this.produtos = produtos)
      );
    }
  }
}

</script>

<style>

</style>
